import React from 'react';
import { Check, X } from 'lucide-react';
export function Audience() {
  return <section className="py-12 md:py-16 bg-charcoal-800/50" data-id="element-1">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-2">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-3">
          {/* For You */}
          <div data-id="element-4">
            <h3 className="text-2xl font-serif text-cream-100 mb-6 flex items-center gap-3" data-id="element-5">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-green-900/30 border border-green-500/30 text-green-400" data-id="element-6">
                <Check className="w-4 h-4" data-id="element-7" />
              </span>
              Esto es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-8">
              {['Están cansados, pero aún hay respeto', 'Te duele la frialdad y quieres volver a conectar', 'Ya intentaste hablar y termina mal', 'Quieres algo práctico, corto y repetible'].map((item, i) => <li key={i} className="flex items-start gap-3 text-cream-200/80" data-id="element-9">
                  <Check className="w-5 h-5 text-green-500/70 flex-shrink-0 mt-0.5" data-id="element-10" />
                  <span data-id="element-11">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div data-id="element-12">
            <h3 className="text-2xl font-serif text-cream-100 mb-6 flex items-center gap-3" data-id="element-13">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-red-900/30 border border-red-500/30 text-red-400" data-id="element-14">
                <X className="w-4 h-4" data-id="element-15" />
              </span>
              NO es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-16">
              {['Hay violencia, abuso o coerción', 'Hay infidelidad activa sin acuerdos', "Uno ya decidió irse y solo quiere 'cumplir'", 'Buscas terapia de pareja profunda (esto es un reset)'].map((item, i) => <li key={i} className="flex items-start gap-3 text-cream-200/80" data-id="element-17">
                  <X className="w-5 h-5 text-red-500/70 flex-shrink-0 mt-0.5" data-id="element-18" />
                  <span data-id="element-19">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}